import { Component, HostListener, Injector, Input, OnInit, OnDestroy, Output, EventEmitter } from '@angular/core';
import { Router } from '@angular/router';
import { ActiveLogoHeader } from 'src/app/main/_layout/services/active-logo-header';
import { GiftBoxTotalService } from 'src/app/main/_layout/services/gift-box-total.service';
import { GiftBoxService } from 'src/app/main/wishlist/services/gift-box.service';
import { AppComponentBase } from 'src/app/shared/app-component-base';
import { DialogService } from 'primeng/dynamicdialog';
import { OnboardingComponent } from 'src/app/shared/components/onboarding/onboarding.component';
import { OnboardingStep, UserType } from '@proxy/users';
import { Subscription } from 'rxjs';

@Component({
  selector: 'app-header-menu',
  templateUrl: './header-menu.component.html',
  styleUrls: ['./header-menu.component.scss'],
})
export class HeaderMenuComponent extends AppComponentBase implements OnInit, OnDestroy {
  @Input() screen = 'page';
  @Input() onboardingStep: OnboardingStep = OnboardingStep.Step5_Done;
  @Output() finalStep = new EventEmitter<string>();
  @Input() userType: UserType = null;

  giftTotal = 0;
  isMobileScreen = false;
  currentUrl = '';
  private subscriptions: Subscription[] = [];

  menuItems = [
    {
      id: 0,
      url: '/main/wishlist/creator-view',
      text: '::Wishlist:MenuHeader:Wishlist',
      icon: 'assets/images/icon/svg/gift-box-icon.svg',
    },
    {
      id: 1,
      url: '/main/notification',
      text: '::Wishlist:MenuHeader:Feed',
      icon: 'assets/images/icon/svg/message.svg',
    },
    {
      id: 2,
      url: '/main/creator-search',
      text: '::Wishlist:MenuHeader:Search',
      icon: 'assets/images/icon/svg/filter.svg',
    },
  ];

  @HostListener('window:resize', ['$event'])
  getScreenSize() {
    this.isMobileScreen = window.innerWidth <= 575;
  }
  constructor(
    injector: Injector,
    private router: Router,
    private giftBoxService: GiftBoxService,
    private giftBoxTotalService: GiftBoxTotalService,
    private activeLogoHeader: ActiveLogoHeader,
    private dialogService: DialogService
  ) {
    super(injector);
  }

  getHiddenStep() {
    return this.onboardingStep === OnboardingStep.Step5_Done || this.userType === UserType.Fan;
  }

  getProgressPercentage(): number {
    if (!this.onboardingStep && this.onboardingStep !== 0) return 0;
    
    // Mapping onboarding steps to percentages
    const stepToPercentage = {
      [OnboardingStep.Step1_Profile]: 25,
      [OnboardingStep.Step2_Address]: 50,
      [OnboardingStep.Step3_Wishlist]: 75,
      [OnboardingStep.Step4_Share_Twitter]: 100,
    };
    
    return stepToPercentage[this.onboardingStep] || 0;
  }

  getCurrentStep(): number {
    if (!this.onboardingStep && this.onboardingStep !== 0) return 1;
    return this.onboardingStep+1;
  }

  getTotalSteps(): number {
    return 4; // Total steps: Profile, Address, Wishlist, Share, Done
  }

  ngOnInit(): void {
    this.getScreenSize();
    this.currentUrl = this.router.url.split(/[?#]/)[0];
    const giftSub = this.giftBoxTotalService.getData().subscribe(data => {
      this.giftTotal = data >= 100 ? '99+' : data;
    });
    this.subscriptions.push(giftSub);

    const logoSub = this.activeLogoHeader.getData().subscribe(s => {
      if (s) {
        this.activeLogo();
      }
    });
    this.subscriptions.push(logoSub);

    const urlSub = this.activeLogoHeader.getUrlCurrent().subscribe(s => {
      if (s) {
        this.changeMenu(s);
      }
    });
    this.subscriptions.push(urlSub);
    console.log(this.onboardingStep)
  }

  ngOnDestroy(): void {
    this.subscriptions.forEach(sub => sub.unsubscribe());
  }

  openGiptBox() {
    this.giftBoxService.setData(true);
    const buttonElement = document.querySelector('.bg-light');
    if (buttonElement) {
      buttonElement.classList.add('no-scroll');
    }
  }

  isMenuItemActive(url: string) {
    if (this.currentUrl === url) {
      return true;
    }
    return false;
  }

  isCreatorViewPage() {
    return this.currentUrl.includes('/main/wishlist/creator-view');
  }

  activeLogo() {
    this.changeMenu('/main/wishlist/creator-view');
  }

  changeMenu(url: string) {
    this.currentUrl = url;
  }

  openNewWindow(url: string) {
    const fullUrl = `${window.location.origin}${url}`;
    const currentUrl = window.location.href;

    if (currentUrl.includes(`${window.location.origin}/home`)) {
      this.router.navigateByUrl(url);
    } else {
      // Open popup
      window.opener = 'differentPageHome';
      window.open(
        fullUrl,
        '_blank',
        'width=500,height=600,top=100,left=100,resizable=yes,scrollbars=yes'
      );
    }
  }

  openSetupGuid() {
    let contentStyle = {
      overflow: 'hidden',
      padding: '0px',
      borderRadius: '8px',
    };
    let width = '50%';

    if (this.isMobileScreen) {
      contentStyle = {
        overflow: 'hidden',
        padding: '0px',
        borderRadius: '8px',
      };
      width = '90%';
    }
    const ref = this.dialogService.open(OnboardingComponent, {
      header: '',
      width: width,
      contentStyle: contentStyle,
      baseZIndex: 10000,
      closeOnEscape: false,
      closable: false,
      modal: true,
      dismissableMask: false,
      styleClass: 'onboarding-dialog',
      showHeader: false,
      style: { 'flex-direction': 'unset' },
      data: { 
        step: this.onboardingStep,
        onStepChange: (newStep: OnboardingStep) => {
          this.onboardingStep = newStep;
        }
      },
    });

    ref.onClose.subscribe((result: any) => {
      if (result?.onboardingStep > OnboardingStep.Step1_Profile) {
        this.onboardingStep = result?.onboardingStep;
        if (result?.onboardingStep == OnboardingStep.Step5_Done) {
          this.getHiddenStep();
        }
        this.finalStep.emit(null);
      }
    });
  }

  navigateToProfile() {
    this.router.navigate(['/main/profile-setting']);
  }
}
